import React, { forwardRef, useCallback } from 'react';
import styled from 'styled-components';
import Tooltip from '@components/dataDisplay/Tooltip';
import Button from '@components/dataEntry/button/Button';
import { deleteBanner } from '@store/firebase/banner/delete-banner';
import { useNavigate } from 'react-router-dom';

const BannerWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  /* max-height: 80px; */
`;

const BannerBox = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    /* width: 200px; */
    /* height: 40px; */
    width: fit-content;
    max-width: 100%;
  }
`;
const ButtonWrap = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

type Props = {
  data: any;
  isEdit?: boolean;
  docId?: string;
  handleUpdate?: () => void;
  [propName: string]: any;
};

function BannerItem({ data, isEdit, docId, handleUpdate, ...props }, ref) {
  const { imgURL, name, linkto, directImgURL, openInNewTab } = data;
  const navigate = useNavigate();

  const resolveBannerLink = useCallback((rawLink: string) => {
    const link = (rawLink || '').trim();
    if (!link) return { href: '', internalPath: null as string | null };

    if (link.startsWith('/')) {
      return { href: link, internalPath: link };
    }

    if (!/^https?:\/\//i.test(link)) {
      const internalPath = `/${link.replace(/^\/+/, '')}`;
      return { href: internalPath, internalPath };
    }

    try {
      const parsed = new URL(link);
      const isSameOrigin = parsed.origin === window.location.origin;
      if (isSameOrigin) {
        const internalPath = `${parsed.pathname}${parsed.search}${parsed.hash}`;
        return { href: link, internalPath };
      }
      return { href: link, internalPath: null };
    } catch (error) {
      const internalPath = `/${link.replace(/^\/+/, '')}`;
      return { href: internalPath, internalPath };
    }
  }, []);

  const { href, internalPath } = resolveBannerLink(linkto || '');

  const handleOpenBanner = useCallback(
    (e) => {
      if (isEdit) {
        e.preventDefault();
        return;
      }

      if (openInNewTab) {
        e.preventDefault();
        const openTarget = href || internalPath || linkto;
        if (openTarget) {
          window.open(openTarget, '_blank', 'noopener,noreferrer');
        }
        return;
      }

      if (internalPath) {
        e.preventDefault();
        navigate(internalPath);
      }
    },
    [isEdit, openInNewTab, href, internalPath, linkto, navigate],
  );

  const handleDelete = useCallback(
    (e) => {
      // e.stopPropagation();

      if (data) {
        deleteBanner(imgURL, docId);
      }
    },
    [data, imgURL, docId],
  );

  return (
    <BannerWrap ref={ref}>
      <BannerBox
        href={isEdit ? 'javascript:void(0);' : href}
        target={isEdit || !openInNewTab ? '' : '_blank'}
        rel={isEdit || !openInNewTab ? undefined : 'noopener noreferrer'}
        onClick={handleOpenBanner}
        {...props}
      >
        <Tooltip message={name} direction="bottom">
          <img src={directImgURL || imgURL} alt={name} loading="lazy" />
        </Tooltip>
      </BannerBox>
      {isEdit && (
        <ButtonWrap>
          <Button size="sm" onClick={handleUpdate}>
            수정
          </Button>
          <Button size="sm" onClick={handleDelete}>
            삭제
          </Button>
        </ButtonWrap>
      )}
    </BannerWrap>
  );
}

export default forwardRef(BannerItem);
